import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetControlGroup = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (id: string, controlGroupEnabled: boolean, controlGroupWeight: number) => {
      // stop rogue values getting through
      if (controlGroupWeight < 0) {
        controlGroupWeight = 0;
      } else if (controlGroupWeight > 100) {
        controlGroupWeight = 100;
      }

      dispatch({
        type: 'SET_CONTROL_GROUP',
        payload: {
          id,
          controlGroupEnabled,
          controlGroupWeight,
        },
      });
    },
    [dispatch],
  );
};
